import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM152,
    ContenidoM152,
    ZonaCentralM152,
    PanelIzquierdoM152,
    PanelDerechoM152,
    EscenaM152,
    RespuestaM152,
    AmigosM152,
    BottomM152
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 5;

const MIN_PERSONAS = 2;
const MAX_PERSONAS = 5;

const MAX_PARTES = 12;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222';

const miniInstrucciones =
    'Repartí el entero en partes iguales y escribí cuánto le toca a cada uno.';


// ============================================================================
// AMIGOS
// ============================================================================

const AMIGOS = [

    {
        nombre: 'Pepito',
        color: '#4FA3D1'
    },

    {
        nombre: 'Juana',
        color: '#F06292'
    },

    {
        nombre: 'Tomi',
        color: '#66BB6A'
    },

    {
        nombre: 'Lola',
        color: '#FFA726'
    },

    {
        nombre: 'Fran',
        color: '#AB47BC'
    }

];


// ============================================================================
// SITUACIONES
// ============================================================================

const SITUACIONES = [

    {
        forma: 'pizza',
        objeto: 'la pizza',
        inicio: 'Tenemos 1 pizza.',
        pregunta:
            '¿Cuánta pizza le toca a cada uno?'
    },

    {
        forma: 'chocolate',
        objeto: 'el chocolate',
        inicio: 'Tenemos 1 chocolate.',
        pregunta:
            '¿Cuánto chocolate le toca a cada uno?'
    },

    {
        forma: 'botella',
        objeto: 'la gaseosa',
        inicio: 'Tenemos 1 botella de gaseosa.',
        pregunta:
            '¿Cuánta gaseosa le toca a cada uno?'
    },

    {
        forma: 'helado',
        objeto: 'el helado',
        inicio: 'Tenemos 1 kilo de helado.',
        pregunta:
            '¿Cuánto helado le toca a cada uno?'
    },

    {
        forma: 'ruta',
        objeto: 'el camino',
        inicio: 'Vamos a la Costa en auto.',
        pregunta:
            '¿Qué parte del camino maneja cada uno?'
    }

];


// ============================================================================
// FUNCIONES GENERALES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const numeroRandom = (
    min,
    max
) => {

    return Math.floor(
        Math.random() *
        (
            max -
            min +
            1
        )
    ) + min;
};


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


const colorDe = (
    amigo
) => {

    if (
        amigo === null ||
        amigo === undefined
    ) {

        return null;
    }


    return AMIGOS[
        amigo
    ].color;
};


// ============================================================================
// GENERAR EJERCICIO
// ============================================================================

const generarEjercicio = (
    situacion,
    index
) => {

    const personas =
        numeroRandom(
            MIN_PERSONAS,
            MAX_PERSONAS
        );


    let lineas;


    if (
        situacion.forma ===
        'ruta'
    ) {

        lineas = [

            situacion.inicio,

            `Somos ${personas} para manejar.`,

            'Cada uno maneja la misma parte del camino.'

        ];

    } else {

        lineas = [

            situacion.inicio,

            `Somos ${personas} amigos.`,

            `Repartimos ${situacion.objeto} en partes iguales.`

        ];
    }


    return {

        ...situacion,

        id:
            `${index + 1}`,

        personas,

        lineas
    };
};


// ============================================================================
// SECTOR DE CÍRCULO
// ============================================================================

const sector = (
    cx,
    cy,
    r,
    a0,
    a1
) => {

    if (
        a1 - a0 >=
        359.99
    ) {

        return (
            `M${cx - r} ${cy}
             A${r} ${r} 0 1 1 ${cx + r} ${cy}
             A${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
        );
    }


    const punto = (
        angulo
    ) => [

        cx +
        r *
        Math.sin(
            (
                angulo *
                Math.PI
            ) /
            180
        ),

        cy -
        r *
        Math.cos(
            (
                angulo *
                Math.PI
            ) /
            180
        )
    ];


    const [
        x0,
        y0
    ] = punto(
        a0
    );


    const [
        x1,
        y1
    ] = punto(
        a1
    );


    const large =
        a1 - a0 >
        180

            ? 1
            : 0;


    return (
        `M${cx} ${cy}
         L${x0} ${y0}
         A${r} ${r} 0 ${large} 1 ${x1} ${y1}
         Z`
    );
};


const cortesRadiales = (
    cx,
    cy,
    r,
    partes,
    props
) => {

    if (
        partes <
        2
    ) {

        return null;
    }


    return range(
        partes
    )
        .map(
            index => {

                const angulo =
                    (
                        index *
                        360 /
                        partes
                    ) *
                    (
                        Math.PI /
                        180
                    );


                return (

                    <line
                        key={index}
                        x1={cx}
                        y1={cy}
                        x2={
                            cx +
                            r *
                            Math.sin(
                                angulo
                            )
                        }
                        y2={
                            cy -
                            r *
                            Math.cos(
                                angulo
                            )
                        }
                        {...props}
                    />
                );
            }
        );
};


// ============================================================================
// PIZZA
// ============================================================================

const OLIVAS = [

    [150, 70],
    [205, 95],
    [225, 150],
    [200, 205],
    [150, 228],
    [95, 205],
    [75, 150],
    [100, 95],
    [150, 120],
    [178, 168],
    [122, 172]

];


const Pizza = ({
    partes,
    asign,
    onPart,
    activo
}) => {

    const cx = 150;
    const cy = 150;

    const paso =
        360 /
        partes;


    return (

        <svg
            viewBox="0 0 300 300"
            role="img"
            aria-label="Pizza"
        >

            <circle
                cx={cx}
                cy={cy}
                r={142}
                fill="#FFFFFF"
                stroke="#CFCFCF"
                strokeWidth={3}
            />


            <g
                pointerEvents="none"
            >

                <circle
                    cx={cx}
                    cy={cy}
                    r={128}
                    fill="#D99A4E"
                />

                <circle
                    cx={cx}
                    cy={cy}
                    r={112}
                    fill="#F7D774"
                />


                {
                    OLIVAS.map(
                        (
                            [
                                x,
                                y
                            ],
                            index
                        ) => (

                            <g
                                key={
                                    index
                                }
                            >

                                <circle
                                    cx={x}
                                    cy={y}
                                    r={7}
                                    fill="#2E3B1F"
                                />

                                <circle
                                    cx={x}
                                    cy={y}
                                    r={2.5}
                                    fill="#7A8A55"
                                />

                            </g>
                        )
                    )
                }


                {
                    range(
                        partes
                    )
                        .map(
                            index => {

                                const color =
                                    colorDe(
                                        asign[
                                            index
                                        ]
                                    );


                                if (
                                    !color
                                ) {

                                    return null;
                                }


                                return (

                                    <path
                                        key={
                                            index
                                        }
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                128,
                                                index *
                                                paso,
                                                (
                                                    index +
                                                    1
                                                ) *
                                                paso
                                            )
                                        }
                                        fill={
                                            color
                                        }
                                        opacity={
                                            0.6
                                        }
                                    />
                                );
                            }
                        )
                }


                {
                    cortesRadiales(
                        cx,
                        cy,
                        130,
                        partes,
                        {
                            stroke:
                                '#FFFFFF',

                            strokeWidth:
                                5
                        }
                    )
                }

            </g>


            {
                range(
                    partes
                )
                    .map(
                        index => (

                            <path
                                key={
                                    index
                                }
                                d={
                                    sector(
                                        cx,
                                        cy,
                                        130,
                                        index *
                                        paso,
                                        (
                                            index +
                                            1
                                        ) *
                                        paso
                                    )
                                }
                                fill="transparent"
                                style={{
                                    cursor:
                                        activo

                                            ? 'pointer'
                                            : 'default'
                                }}
                                onClick={() =>
                                    onPart(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// CHOCOLATE
// ============================================================================

const Chocolate = ({
    partes,
    asign,
    onPart,
    activo
}) => {

    const x0 = 20;
    const y0 = 20;

    const W = 360;
    const H = 120;

    const cols = 12;
    const rows = 2;

    const cw =
        W /
        cols;

    const ch =
        H /
        rows;

    const pw =
        W /
        partes;


    return (

        <svg
            viewBox="0 0 400 160"
            role="img"
            aria-label="Chocolate"
        >

            <g
                pointerEvents="none"
            >

                <rect
                    x={x0 - 6}
                    y={y0 - 6}
                    width={W + 12}
                    height={H + 12}
                    rx={10}
                    fill="#7B4A2A"
                />


                {
                    range(
                        cols
                    )
                        .map(
                            columna =>

                                range(
                                    rows
                                )
                                    .map(
                                        fila => {

                                            const x =
                                                x0 +
                                                columna *
                                                cw +
                                                3;

                                            const y =
                                                y0 +
                                                fila *
                                                ch +
                                                3;

                                            const width =
                                                cw -
                                                6;

                                            const height =
                                                ch -
                                                6;


                                            return (

                                                <g
                                                    key={
                                                        `${columna}-${fila}`
                                                    }
                                                >

                                                    <rect
                                                        x={x}
                                                        y={y}
                                                        width={
                                                            width
                                                        }
                                                        height={
                                                            height
                                                        }
                                                        rx={3}
                                                        fill="#94592F"
                                                    />

                                                    <path
                                                        d={
                                                            `M${x + 2} ${y + height - 2}
                                                             L${x + 2} ${y + 2}
                                                             L${x + width - 2} ${y + 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#B07446"
                                                        strokeWidth={2.5}
                                                        strokeLinecap="round"
                                                    />

                                                    <path
                                                        d={
                                                            `M${x + width - 2} ${y + 2}
                                                             L${x + width - 2} ${y + height - 2}
                                                             L${x + 2} ${y + height - 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#5A3420"
                                                        strokeWidth={2.5}
                                                        strokeLinecap="round"
                                                    />

                                                </g>
                                            );
                                        }
                                    )
                        )
                }


                {
                    range(
                        partes
                    )
                        .map(
                            index => {

                                const color =
                                    colorDe(
                                        asign[
                                            index
                                        ]
                                    );


                                if (
                                    !color
                                ) {

                                    return null;
                                }


                                return (

                                    <rect
                                        key={
                                            index
                                        }
                                        x={
                                            x0 +
                                            index *
                                            pw
                                        }
                                        y={
                                            y0 -
                                            6
                                        }
                                        width={
                                            pw
                                        }
                                        height={
                                            H +
                                            12
                                        }
                                        fill={
                                            color
                                        }
                                        opacity={
                                            0.6
                                        }
                                    />
                                );
                            }
                        )
                }


                {
                    range(
                        partes -
                        1
                    )
                        .map(
                            index => (

                                <line
                                    key={
                                        index
                                    }
                                    x1={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y1={
                                        y0 -
                                        8
                                    }
                                    x2={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y2={
                                        y0 +
                                        H +
                                        8
                                    }
                                    stroke="#FFFFFF"
                                    strokeWidth={5}
                                />
                            )
                        )
                }

            </g>


            {
                range(
                    partes
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    x0 +
                                    index *
                                    pw
                                }
                                y={
                                    y0 -
                                    6
                                }
                                width={
                                    pw
                                }
                                height={
                                    H +
                                    12
                                }
                                fill="transparent"
                                style={{
                                    cursor:
                                        activo

                                            ? 'pointer'
                                            : 'default'
                                }}
                                onClick={() =>
                                    onPart(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// BOTELLA
// ============================================================================

const Botella = ({
    partes,
    asign,
    onPart,
    activo
}) => {

    const top = 105;
    const bottom = 290;

    const alto =
        bottom -
        top;

    const altoParte =
        alto /
        partes;

    const contorno =
        'M62 22 h36 v33 q32 10 32 50 v165 q0 20 -20 20 h-60 q-20 0 -20 -20 v-165 q0 -40 32 -50 z';


    return (

        <svg
            viewBox="0 0 160 300"
            role="img"
            aria-label="Botella de gaseosa"
        >

            <defs>

                <clipPath
                    id="clip-reparto-botella"
                >

                    <path
                        d={
                            contorno
                        }
                    />

                </clipPath>

            </defs>


            <g
                pointerEvents="none"
            >

                <path
                    d={contorno}
                    fill="#F7FBFC"
                />


                <g
                    clipPath="url(#clip-reparto-botella)"
                >

                    <rect
                        x={0}
                        y={top}
                        width={160}
                        height={
                            alto +
                            10
                        }
                        fill="#F28C28"
                    />


                    {
                        range(
                            partes
                        )
                            .map(
                                index => {

                                    const color =
                                        colorDe(
                                            asign[
                                                index
                                            ]
                                        );


                                    if (
                                        !color
                                    ) {

                                        return null;
                                    }


                                    return (

                                        <rect
                                            key={
                                                index
                                            }
                                            x={0}
                                            y={
                                                bottom -
                                                (
                                                    index +
                                                    1
                                                ) *
                                                altoParte
                                            }
                                            width={
                                                160
                                            }
                                            height={
                                                altoParte
                                            }
                                            fill={
                                                color
                                            }
                                            opacity={
                                                0.65
                                            }
                                        />
                                    );
                                }
                            )
                    }


                    {
                        range(
                            partes -
                            1
                        )
                            .map(
                                index => (

                                    <line
                                        key={
                                            index
                                        }
                                        x1={0}
                                        y1={
                                            bottom -
                                            (
                                                index +
                                                1
                                            ) *
                                            altoParte
                                        }
                                        x2={160}
                                        y2={
                                            bottom -
                                            (
                                                index +
                                                1
                                            ) *
                                            altoParte
                                        }
                                        stroke="#FFFFFF"
                                        strokeWidth={4}
                                    />
                                )
                            )
                    }

                </g>


                <path
                    d={contorno}
                    fill="none"
                    stroke={INK}
                    strokeWidth={3}
                />


                <rect
                    x={58}
                    y={6}
                    width={44}
                    height={20}
                    rx={4}
                    fill="#C62828"
                    stroke={INK}
                    strokeWidth={2}
                />

            </g>


            {
                range(
                    partes
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={28}
                                y={
                                    bottom -
                                    (
                                        index +
                                        1
                                    ) *
                                    altoParte
                                }
                                width={104}
                                height={
                                    altoParte
                                }
                                fill="transparent"
                                style={{
                                    cursor:
                                        activo

                                            ? 'pointer'
                                            : 'default'
                                }}
                                onClick={() =>
                                    onPart(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// HELADO
// ============================================================================

const Helado = ({
    partes,
    asign,
    onPart,
    activo
}) => {

    const r = 110;
    const ry = 44;

    const k =
        ry /
        r;

    const cx = 160;
    const topY = 70;

    const paso =
        360 /
        partes;


    return (

        <svg
            viewBox="0 0 320 260"
            role="img"
            aria-label="Pote de un kilo de helado"
        >

            <g
                pointerEvents="none"
            >

                <path
                    d={
                        `M${cx - 128} ${topY}
                         L${cx - 98} ${topY + 160}
                         Q${cx} ${topY + 186} ${cx + 98} ${topY + 160}
                         L${cx + 128} ${topY} Z`
                    }
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={3}
                    strokeLinejoin="round"
                />


                <text
                    x={cx}
                    y={
                        topY +
                        120
                    }
                    textAnchor="middle"
                    fontSize="22"
                    fontWeight="800"
                    fill="#9E9E9E"
                    letterSpacing="2"
                >
                    1 KG
                </text>


                <ellipse
                    cx={cx}
                    cy={topY}
                    rx={128}
                    ry={50}
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={3}
                />

            </g>


            <g
                transform={
                    `translate(${cx} ${topY}) scale(1 ${k})`
                }
            >

                <g
                    pointerEvents="none"
                >

                    <circle
                        cx={0}
                        cy={0}
                        r={r}
                        fill="#C68B4E"
                    />


                    {
                        range(
                            partes
                        )
                            .map(
                                index => {

                                    const color =
                                        colorDe(
                                            asign[
                                                index
                                            ]
                                        );


                                    if (
                                        !color
                                    ) {

                                        return null;
                                    }


                                    return (

                                        <path
                                            key={
                                                index
                                            }
                                            d={
                                                sector(
                                                    0,
                                                    0,
                                                    r,
                                                    index *
                                                    paso,
                                                    (
                                                        index +
                                                        1
                                                    ) *
                                                    paso
                                                )
                                            }
                                            fill={
                                                color
                                            }
                                            opacity={
                                                0.65
                                            }
                                        />
                                    );
                                }
                            )
                    }


                    {
                        cortesRadiales(
                            0,
                            0,
                            r,
                            partes,
                            {
                                stroke:
                                    '#FFFFFF',

                                strokeWidth:
                                    4,

                                vectorEffect:
                                    'non-scaling-stroke'
                            }
                        )
                    }

                </g>


                {
                    range(
                        partes
                    )
                        .map(
                            index => (

                                <path
                                    key={
                                        index
                                    }
                                    d={
                                        sector(
                                            0,
                                            0,
                                            r,
                                            index *
                                            paso,
                                            (
                                                index +
                                                1
                                            ) *
                                            paso
                                        )
                                    }
                                    fill="transparent"
                                    style={{
                                        cursor:
                                            activo

                                                ? 'pointer'
                                                : 'default'
                                    }}
                                    onClick={() =>
                                        onPart(
                                            index
                                        )
                                    }
                                />
                            )
                        )
                }

            </g>

        </svg>
    );
};


// ============================================================================
// RUTA
// ============================================================================

const Ruta = ({
    partes,
    asign,
    onPart,
    activo
}) => {

    const x1 = 70;
    const x2 = 690;

    const y = 70;

    const largo =
        x2 -
        x1;

    const anchoParte =
        largo /
        partes;


    return (

        <svg
            viewBox="0 0 760 160"
            role="img"
            aria-label="Camino a la Costa"
        >

            <g
                pointerEvents="none"
            >

                <rect
                    x={x1}
                    y={
                        y -
                        20
                    }
                    width={
                        largo
                    }
                    height={40}
                    rx={4}
                    fill="#555"
                />


                {
                    range(
                        partes
                    )
                        .map(
                            index => {

                                const color =
                                    colorDe(
                                        asign[
                                            index
                                        ]
                                    );


                                if (
                                    !color
                                ) {

                                    return null;
                                }


                                return (

                                    <rect
                                        key={
                                            index
                                        }
                                        x={
                                            x1 +
                                            index *
                                            anchoParte
                                        }
                                        y={
                                            y -
                                            20
                                        }
                                        width={
                                            anchoParte
                                        }
                                        height={40}
                                        fill={
                                            color
                                        }
                                        opacity={
                                            0.75
                                        }
                                    />
                                );
                            }
                        )
                }


                <line
                    x1={
                        x1 +
                        6
                    }
                    y1={y}
                    x2={
                        x2 -
                        6
                    }
                    y2={y}
                    stroke="#FFFFFF"
                    strokeWidth={3}
                    strokeDasharray="14 12"
                />


                {
                    range(
                        partes +
                        1
                    )
                        .map(
                            index => {

                                const px =
                                    x1 +
                                    index *
                                    anchoParte;


                                return (

                                    <g
                                        key={
                                            index
                                        }
                                    >

                                        {
                                            index >
                                            0 &&
                                            index <
                                            partes && (

                                                <line
                                                    x1={
                                                        px
                                                    }
                                                    y1={
                                                        y -
                                                        22
                                                    }
                                                    x2={
                                                        px
                                                    }
                                                    y2={
                                                        y +
                                                        22
                                                    }
                                                    stroke="#FFFFFF"
                                                    strokeWidth={5}
                                                />
                                            )
                                        }


                                        <rect
                                            x={
                                                px -
                                                4
                                            }
                                            y={
                                                y +
                                                24
                                            }
                                            width={8}
                                            height={22}
                                            rx={2}
                                            fill="#FFFFFF"
                                            stroke={INK}
                                            strokeWidth={2}
                                        />

                                        <rect
                                            x={
                                                px -
                                                4
                                            }
                                            y={
                                                y +
                                                24
                                            }
                                            width={8}
                                            height={7}
                                            fill={MARK}
                                        />

                                    </g>
                                );
                            }
                        )
                }


                <text
                    x={x1}
                    y={
                        y +
                        76
                    }
                    textAnchor="middle"
                    fontSize="18"
                    fontWeight="700"
                    fill={INK}
                >
                    Buenos Aires
                </text>


                <text
                    x={x2}
                    y={
                        y +
                        76
                    }
                    textAnchor="middle"
                    fontSize="18"
                    fontWeight="700"
                    fill={INK}
                >
                    La Costa
                </text>

            </g>


            {
                range(
                    partes
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    x1 +
                                    index *
                                    anchoParte
                                }
                                y={
                                    y -
                                    22
                                }
                                width={
                                    anchoParte
                                }
                                height={44}
                                fill="transparent"
                                style={{
                                    cursor:
                                        activo

                                            ? 'pointer'
                                            : 'default'
                                }}
                                onClick={() =>
                                    onPart(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// FORMAS
// ============================================================================

const FORMAS = {

    pizza:
        Pizza,

    chocolate:
        Chocolate,

    botella:
        Botella,

    helado:
        Helado,

    ruta:
        Ruta
};


// ============================================================================
// AMIGO
// ============================================================================

const Amigo = ({
    amigo,
    seleccionado,
    cantidad,
    onClick,
    activo
}) => {

    return (

        <button
            type="button"
            onClick={
                onClick
            }
            disabled={
                !activo
            }
            aria-pressed={
                seleccionado
            }
            style={{
                fontFamily:
                    'Nunito',

                background:
                    '#FFFFFF',

                border:
                    `3px solid ${
                        seleccionado

                            ? INK
                            : 'transparent'
                    }`,

                borderRadius:
                    16,

                padding:
                    '6px 9px',

                cursor:
                    activo

                        ? 'pointer'
                        : 'default',

                display:
                    'flex',

                flexDirection:
                    'column',

                alignItems:
                    'center',

                gap:
                    3,

                position:
                    'relative'
            }}
        >

            <svg
                width={58}
                height={58}
                viewBox="0 0 64 64"
                aria-hidden="true"
            >

                <circle
                    cx={32}
                    cy={32}
                    r={29}
                    fill={
                        amigo.color
                    }
                />

                <circle
                    cx={23}
                    cy={27}
                    r={3.5}
                    fill={INK}
                />

                <circle
                    cx={41}
                    cy={27}
                    r={3.5}
                    fill={INK}
                />

                <path
                    d="M21 39 Q32 49 43 39"
                    fill="none"
                    stroke={INK}
                    strokeWidth={3}
                    strokeLinecap="round"
                />

            </svg>


            <span
                style={{
                    fontSize:
                        16,

                    fontWeight:
                        700,

                    color:
                        INK
                }}
            >
                {
                    amigo.nombre
                }
            </span>


            {
                cantidad >
                0 && (

                    <span
                        style={{
                            position:
                                'absolute',

                            top:
                                1,

                            right:
                                1,

                            minWidth:
                                24,

                            height:
                                24,

                            borderRadius:
                                12,

                            background:
                                INK,

                            color:
                                '#FFFFFF',

                            fontSize:
                                14,

                            fontWeight:
                                700,

                            display:
                                'flex',

                            alignItems:
                                'center',

                            justifyContent:
                                'center'
                        }}
                    >
                        {
                            cantidad
                        }
                    </span>
                )
            }

        </button>
    );
};


// ============================================================================
// BOTÓN CONTADOR
// ============================================================================

const botonContador = {

    fontFamily:
        'Nunito',

    fontSize:
        22,

    fontWeight:
        700,

    width:
        42,

    height:
        36,

    borderRadius:
        10,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


// ============================================================================
// CONTADOR
// ============================================================================

const Contador = ({
    valor,
    onCambio,
    min,
    disabled,
    etiqueta
}) => {


    const restar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? min

                : Math.max(
                    min,
                    valor -
                    1
                )
        );
    };


    const sumar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? Math.max(
                    min,
                    1
                )

                : Math.min(
                    MAX_PARTES,
                    valor +
                    1
                )
        );
    };


    return (

        <div
            style={{
                display:
                    'flex',

                alignItems:
                    'center',

                gap:
                    10
            }}
        >

            <button
                type="button"
                style={{
                    ...botonContador,

                    opacity:
                        disabled
                            ? 0.4
                            : 1
                }}
                disabled={
                    disabled
                }
                aria-label={
                    `Restar ${etiqueta}`
                }
                onClick={
                    restar
                }
            >
                −
            </button>


            <div
                style={{
                    width:
                        56,

                    height:
                        56,

                    border:
                        `3px solid ${INK}`,

                    borderRadius:
                        10,

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    fontFamily:
                        'Nunito',

                    fontSize:
                        30,

                    fontWeight:
                        700,

                    color:

                        valor === null

                            ? '#AAAAAA'
                            : INK
                }}
            >
                {
                    valor === null
                        ? '?'
                        : valor
                }
            </div>


            <button
                type="button"
                style={{
                    ...botonContador,

                    opacity:
                        disabled
                            ? 0.4
                            : 1
                }}
                disabled={
                    disabled
                }
                aria-label={
                    `Sumar ${etiqueta}`
                }
                onClick={
                    sumar
                }
            >
                +
            </button>

        </div>
    );
};


// ============================================================================
// M152
// ============================================================================

const M152 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // ------------------------------------------------------------------------
    // REDUX
    // ------------------------------------------------------------------------

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // ------------------------------------------------------------------------
    // EJERCICIOS
    // ------------------------------------------------------------------------

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(1);


    // ------------------------------------------------------------------------
    // REPARTO
    // ------------------------------------------------------------------------

    const [
        partes,
        setPartes
    ] = useState(1);


    const [
        asign,
        setAsign
    ] = useState([
        null
    ]);


    const [
        sel,
        setSel
    ] = useState(0);


    const [
        fase,
        setFase
    ] = useState(
        'repartir'
    );


    // ------------------------------------------------------------------------
    // FRACCIÓN
    // ------------------------------------------------------------------------

    const [
        num,
        setNum
    ] = useState(null);


    const [
        den,
        setDen
    ] = useState(null);


    // ------------------------------------------------------------------------
    // ESTADO
    // ------------------------------------------------------------------------

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    // ------------------------------------------------------------------------
    // ERRORES
    // ------------------------------------------------------------------------

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // ------------------------------------------------------------------------
    // RESPUESTAS
    // ------------------------------------------------------------------------

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // ------------------------------------------------------------------------
    // EJERCICIO ACTUAL
    // ------------------------------------------------------------------------

    const ejercicioActual =
        ejercicios.length >
        0

            ? ejercicios[
                count -
                1
            ]

            : null;


    const amigos =
        ejercicioActual

            ? AMIGOS.slice(
                0,
                ejercicioActual.personas
            )

            : [];


    const Forma =
        ejercicioActual

            ? FORMAS[
                ejercicioActual.forma
            ]

            : null;


    const repartiendo =
        fase ===
        'repartir';


    const cuenta =
        amigos.map(
            (
                _,
                amigo
            ) =>

                asign.filter(
                    item =>
                        item ===
                        amigo
                ).length
        );


    // ------------------------------------------------------------------------
    // SONIDOS
    // ------------------------------------------------------------------------

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // ------------------------------------------------------------------------
    // ERROR
    // ------------------------------------------------------------------------

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({
            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        TryAgain();


        setTimeout(() => {

            setDisable(
                false
            );

        }, 500);
    };


    // ------------------------------------------------------------------------
    // CAMBIAR PARTES
    // ------------------------------------------------------------------------

    const cambiarPartes = (
        delta
    ) => {

        if (
            disable ||
            !repartiendo
        ) {

            return;
        }


        const nuevasPartes =
            Math.max(
                1,
                Math.min(
                    MAX_PARTES,
                    partes +
                    delta
                )
            );


        if (
            nuevasPartes ===
            partes
        ) {

            return;
        }


        setPartes(
            nuevasPartes
        );


        setAsign(
            Array(
                nuevasPartes
            ).fill(
                null
            )
        );


        setFeedback(
            null
        );
    };


    // ------------------------------------------------------------------------
    // TOCAR PARTE
    // ------------------------------------------------------------------------

    const tocarParte = (
        index
    ) => {

        if (
            disable ||
            !repartiendo
        ) {

            return;
        }


        setAsign(

            asign.map(
                (
                    valor,
                    posicion
                ) => {

                    if (
                        posicion !==
                        index
                    ) {

                        return valor;
                    }


                    if (
                        valor ===
                        sel
                    ) {

                        return null;
                    }


                    return sel;
                }
            )
        );


        setFeedback(
            null
        );
    };


    // ------------------------------------------------------------------------
    // COMPROBAR REPARTO
    // ------------------------------------------------------------------------

    const comprobarReparto = () => {

        const personas =
            ejercicioActual
                .personas;


        if (
            partes <
            personas
        ) {

            marcarError(
                `Somos ${personas} y hay ${partes === 1 ? '1 parte' : `${partes} partes`}. Partí en más partes.`
            );

            return;
        }


        if (
            asign.includes(
                null
            )
        ) {

            marcarError(
                'Hay partes sin dueño. Tocá un amigo y dale su parte.'
            );

            return;
        }


        const sinNada =
            cuenta.findIndex(
                cantidad =>
                    cantidad ===
                    0
            );


        if (
            sinNada >=
            0
        ) {

            marcarError(
                `${amigos[sinNada].nombre} no tiene nada. ¡Dale su parte!`
            );

            return;
        }


        if (
            partes %
            personas !==
            0
        ) {

            marcarError(
                'Así no alcanza para que todos tengan lo mismo. Probá partir en otra cantidad.'
            );

            return;
        }


        const max =
            Math.max(
                ...cuenta
            );


        const min =
            Math.min(
                ...cuenta
            );


        if (
            max !==
            min
        ) {

            const tieneMas =
                amigos[
                    cuenta.indexOf(
                        max
                    )
                ].nombre;


            const tieneMenos =
                amigos[
                    cuenta.indexOf(
                        min
                    )
                ].nombre;


            marcarError(
                `${tieneMas} tiene más que ${tieneMenos}. Todos tienen que tener lo mismo.`
            );

            return;
        }


        setFase(
            'escribir'
        );


        setFeedback({
            ok:
                true,

            text:
                '¡Muy bien! Todos tienen lo mismo.'
        });


        GoodWork();
    };


    // ------------------------------------------------------------------------
    // COMPROBAR FRACCIÓN
    // ------------------------------------------------------------------------

    const comprobarFraccion = () => {

        const personas =
            ejercicioActual
                .personas;


        if (
            num === null ||
            den === null
        ) {

            marcarError(
                'Completá los dos números.'
            );

            return;
        }


        // --------------------------------------------------------------------
        // SE ACEPTAN FRACCIONES EQUIVALENTES
        // --------------------------------------------------------------------

        if (
            num *
            personas !==
            den
        ) {

            if (
                den !==
                partes &&
                den !==
                personas
            ) {

                marcarError(
                    `¿En cuántas partes partiste ${ejercicioActual.objeto}?`
                );

            } else {

                marcarError(
                    '¿Cuántas partes le diste a cada uno?'
                );
            }


            return;
        }


        // --------------------------------------------------------------------
        // CORRECTO
        // --------------------------------------------------------------------

        setFase(
            'listo'
        );


        setDisable(
            true
        );


        setFeedback({
            ok:
                true,

            text:
                '¡Muy bien!'
        });


        GoodWork();


        const nuevaRespuesta =
            `${num}/${den}`;


        const nuevoRespuestasOrden = [

            ...respuestasOrden,

            nuevaRespuesta

        ];


        const nuevoErroresOrden = [

            ...erroresOrden,

            erroresItemActual

        ];


        setRespuestasOrden(
            nuevoRespuestasOrden
        );


        setErroresOrden(
            nuevoErroresOrden
        );


        if (
            count <
            ejercicios.length
        ) {

            setTimeout(() => {

                limpiarEjercicio();


                setCount(
                    contador =>
                        contador +
                        1
                );

            }, 1000);

        } else {

            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 1500);
        }
    };


    // ------------------------------------------------------------------------
    // BOTÓN PLAY
    // ------------------------------------------------------------------------

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            !ejercicioActual
        ) {

            return;
        }


        if (
            fase ===
            'repartir'
        ) {

            comprobarReparto();

            return;
        }


        if (
            fase ===
            'escribir'
        ) {

            comprobarFraccion();
        }
    };


    // ------------------------------------------------------------------------
    // LIMPIAR
    // ------------------------------------------------------------------------

    const limpiarEjercicio = () => {

        setPartes(
            1
        );


        setAsign([
            null
        ]);


        setSel(
            0
        );


        setFase(
            'repartir'
        );


        setNum(
            null
        );


        setDen(
            null
        );


        setFeedback(
            null
        );


        setDisable(
            false
        );


        setErroresItemActual(
            0
        );
    };


    // =========================================================================
    // GENERAR EJERCICIOS
    // =========================================================================

    useEffect(() => {

        const modelo =
            mezclar(
                SITUACIONES
            )
                .slice(
                    0,
                    CANTIDAD_EJERCICIOS
                )
                .map(
                    (
                        situacion,
                        index
                    ) =>

                        generarEjercicio(
                            situacion,
                            index
                        )
                );


        setEjercicios(
            modelo
        );


        dispatch(
            setearEjercicioAction(
                'M152'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M152',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={true}
                    carrito={true}
                    minMay={false}
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !ejercicioActual ||
        !Forma
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM152>


            <HeaderEjercicios
                estrellas={true}
                carrito={true}
                minMay={false}
            />


            <ContenidoM152>


                {/* ========================================================= */}
                {/* CONSIGNA                                                  */}
                {/* ========================================================= */}

                <div
                    style={{
                        fontFamily:
                            'Nunito',

                        textAlign:
                            'center',

                        flexShrink:
                            0
                    }}
                >

                    {
                        ejercicioActual
                            .lineas
                            .map(
                                linea => (

                                    <p
                                        key={
                                            linea
                                        }
                                        style={{
                                            fontSize:
                                                22,

                                            fontWeight:
                                                600,

                                            margin:
                                                '2px 0',

                                            lineHeight:
                                                1.25
                                        }}
                                    >
                                        {
                                            linea
                                        }
                                    </p>
                                )
                            )
                    }

                </div>


                {/* ========================================================= */}
                {/* ZONA CENTRAL                                              */}
                {/* ========================================================= */}

                <ZonaCentralM152>

                    <PanelIzquierdoM152>

                        <EscenaM152
                            $forma={
                                ejercicioActual.forma
                            }
                        >

                            <Forma
                                partes={
                                    partes
                                }
                                asign={
                                    asign
                                }
                                onPart={
                                    tocarParte
                                }
                                activo={
                                    repartiendo &&
                                    !disable
                                }
                            />

                        </EscenaM152>


                        {/* ===================================================== */}
                        {/* PARTIR EN                                             */}
                        {/* ===================================================== */}

                        <div
                            style={{
                                display:
                                    'flex',

                                alignItems:
                                    'center',

                                justifyContent:
                                    'center',

                                gap:
                                    12,

                                fontFamily:
                                    'Nunito',

                                fontSize:
                                    20,

                                fontWeight:
                                    700,

                                flexShrink:
                                    0
                            }}
                        >

                            <span>
                                Partir en:
                            </span>


                            <button
                                type="button"
                                style={{
                                    ...botonContador,

                                    opacity:
                                        disable ||
                                        !repartiendo ||
                                        partes <= 1

                                            ? 0.4
                                            : 1
                                }}
                                disabled={
                                    disable ||
                                    !repartiendo ||
                                    partes <= 1
                                }
                                onClick={() =>
                                    cambiarPartes(
                                        -1
                                    )
                                }
                            >
                                −
                            </button>


                            <span
                                style={{
                                    minWidth:
                                        30,

                                    textAlign:
                                        'center',

                                    fontSize:
                                        26
                                }}
                            >
                                {
                                    partes
                                }
                            </span>


                            <button
                                type="button"
                                style={{
                                    ...botonContador,

                                    opacity:
                                        disable ||
                                        !repartiendo ||
                                        partes >= MAX_PARTES

                                            ? 0.4
                                            : 1
                                }}
                                disabled={
                                    disable ||
                                    !repartiendo ||
                                    partes >= MAX_PARTES
                                }
                                onClick={() =>
                                    cambiarPartes(
                                        1
                                    )
                                }
                            >
                                +
                            </button>

                        </div>


                        {/* ===================================================== */}
                        {/* AMIGOS                                                */}
                        {/* ===================================================== */}

                        <AmigosM152>

                            {
                                amigos.map(
                                    (
                                        amigo,
                                        index
                                    ) => (

                                        <Amigo
                                            key={
                                                amigo.nombre
                                            }
                                            amigo={
                                                amigo
                                            }
                                            seleccionado={
                                                repartiendo &&
                                                sel === index
                                            }
                                            cantidad={
                                                cuenta[index]
                                            }
                                            activo={
                                                repartiendo &&
                                                !disable
                                            }
                                            onClick={() => {

                                                if (
                                                    repartiendo &&
                                                    !disable
                                                ) {

                                                    setSel(
                                                        index
                                                    );
                                                }
                                            }}
                                        />
                                    )
                                )
                            }

                        </AmigosM152>


                        {/* ===================================================== */}
                        {/* AYUDA                                                 */}
                        {/* ===================================================== */}

                        <p
                            style={{
                                fontFamily:
                                    'Nunito',

                                fontSize:
                                    17,

                                color:
                                    '#555555',

                                margin:
                                    0,

                                textAlign:
                                    'center',

                                flexShrink:
                                    0
                            }}
                        >
                            <p
                                style={{
                                    fontFamily:
                                        'Nunito',

                                    fontSize:
                                        17,

                                    color:
                                        '#555555',

                                    margin:
                                        0,

                                    marginTop:
                                        'auto',

                                    paddingTop:
                                        4,

                                    textAlign:
                                        'center',

                                    flexShrink:
                                        0
                                }}
                            >
                                {
                                    repartiendo
                                        ? 'Tocá un amigo. Después tocá las partes que le das.'
                                        : 'Así quedó el reparto.'
                                }
                            </p>
                        </p>

                    </PanelIzquierdoM152>


                    <PanelDerechoM152
                        $visible={
                            fase !== 'repartir'
                        }
                    >

                        {
                            fase !== 'repartir' && (

                                <RespuestaM152>

                                    <p
                                        style={{
                                            fontFamily:
                                                'Nunito',

                                            fontSize:
                                                22,

                                            fontWeight:
                                                700,

                                            textAlign:
                                                'center',

                                            margin:
                                                0,

                                            lineHeight:
                                                1.25
                                        }}
                                    >
                                        {
                                            ejercicioActual
                                                .pregunta
                                        }
                                    </p>


                                    <Contador
                                        valor={
                                            num
                                        }
                                        onCambio={
                                            valor => {

                                                setNum(
                                                    valor
                                                );

                                                setFeedback(
                                                    null
                                                );
                                            }
                                        }
                                        min={0}
                                        disabled={
                                            fase === 'listo'
                                        }
                                        etiqueta="numerador"
                                    />


                                    <div
                                        style={{
                                            width: 80,
                                            height: 4,
                                            background: INK,
                                            borderRadius: 2
                                        }}
                                    />


                                    <Contador
                                        valor={
                                            den
                                        }
                                        onCambio={
                                            valor => {

                                                setDen(
                                                    valor
                                                );

                                                setFeedback(
                                                    null
                                                );
                                            }
                                        }
                                        min={1}
                                        disabled={
                                            fase === 'listo'
                                        }
                                        etiqueta="denominador"
                                    />

                                </RespuestaM152>
                            )
                        }

                    </PanelDerechoM152>

                </ZonaCentralM152>


                {/* ========================================================= */}
                {/* FEEDBACK                                                  */}
                {/* ========================================================= */}

                <p
                    style={{
                        minHeight:
                            24,

                        margin:
                            0,

                        padding:
                            '0 10px',

                        fontFamily:
                            'Nunito',

                        fontSize:
                            18,

                        fontWeight:
                            600,

                        textAlign:
                            'center',

                        flexShrink:
                            0,

                        color:

                            feedback

                                ? feedback.ok

                                    ? OK
                                    : MARK

                                : 'transparent'
                    }}
                    aria-live="polite"
                >
                    {
                        feedback

                            ? feedback.text

                            : '.'
                    }
                </p>


            </ContenidoM152>


            <BottomM152>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        fase ===
                        'listo'
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM152>


        </PantallaM152>
    );
};


export default M152;